import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';
import { useLoginContext } from '../../context';
import { usePlaylistContext } from '../../context/PlaylistContext';
import SpotifyApiService from '../../services/SpotifyApiService';
import { PlaylistStyle } from '../../pages/Playlist/Playlist.style';
import { isEmptyOrNil } from '../../utils';
import AddToPlayListModalSearch from '../AddToPlayListModal/AddToPlayListModalSearch';
import EditAddToPlayListModal from '../AddToPlayListModal/EditAddToPlayListModal';
import SongsTable from '../SongsTable/SearchSongTable';
import DeleteModal from '../Subscriptions/CancelSubscription';
import { EmptySearchState } from './EmptySearchState';

interface SearchSongsTableProps {}

const SearchSongsTable: React.FC<SearchSongsTableProps> = () => {
  const location = useLocation();
  const searchPlaylist = window.location.search.includes('playlist') ? window.location.search : '';

  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [songURI, setSongURI] = useState('');
  const { state: playlistState } = usePlaylistContext();
  const { state, dispatch } = usePlaylistContext();
  const { state: loginState } = useLoginContext();

  const [songtext, setsongtext] = useState('');
  const [page, setPage] = useState(1);
  // Search-as-you-type fires overlapping requests; only the latest query may write results.
  const latestQueryRef = useRef('');
  const clickHandle = (url: any, id: any, image: any, name: any, artist: any, external: any) => {
    if (url !== null) {
      dispatch({
        type: 'UPDATE_SONGS_SEARCH_LIST',
        payload: id,
      });
      if (url === '' || url !== null) {
        dispatch({
          type: 'SET_PREVIEW_SONG',
          payload: {
            url: url,
            id: id,
            name: name,
            artist: artist,
            image: image,
            external: external,
          },
        });
      }
    } else {
      window.open(`${external}`, '_blank');
    }
  };
  // useEffect(() => { console.log(searchPlaylist, 'searchPlaylist') }, [searchPlaylist])
  const clickHandle1 = (url: any, id: any, image: any, name: any, artist: any, external: any) => {
    if (state.previewSong.url === url) {
      dispatch({
        type: 'SET_PREVIEW_SONG',
        payload: {
          url: '',
          id: '',
          name: '',
          artist: '',
          image: '',
          external: '',
        },
      });
    }
  };

  const fetchData = (searchSong, loginState, pagination) => {
    latestQueryRef.current = searchSong;
    if (isEmptyOrNil(searchSong)) return;
    const isStale = () => latestQueryRef.current !== searchSong;
    if (searchSong.includes('https://open.spotify.com/track/')) {
      /**
       * if song is searched by url then it will split "https://open.spotify.com/track/" part
       *  and then get extract the id from the string and then it will search by id"
       */
      searchSong.includes('https://open.spotify.com/track/');
      const slashSplits = searchSong.split('/');
      if (slashSplits?.length) {
        const songId = slashSplits[4].split('?');
        SpotifyApiService.getInstance()
          .getTrack(songId[0])
          .then(genreResponse => {
            if (isStale()) return;
            //   setSongs([genreResponse.data]);
            //   setDisplaySongCover(false);
            const responseData = genreResponse.data;
            let data = [
              {
                key: 1,
                id: responseData?.id,
                title: responseData?.name,
                image: responseData?.album.images[0].url,
                artist: responseData?.artists[0].name,
                externalUrl: responseData.external_urls.spotify,
                previewUrl: responseData?.preview_url,
                clickHandle: clickHandle,
                clickHandle1: clickHandle1,
                songUri: responseData?.uri,
                Edit: () => {},
                popularity: responseData?.popularity ?? '--',
              },
            ];
            dispatch({
              type: 'SET_SONGS_SEARCH_LIST',
              payload: data,
            });
            dispatch({
              type: 'SET_SEARCH_TRACKS_TOTAL',
              payload: 1,
            });
          });
      }
    } else if (searchSong.includes('spotify:track')) {
      const songId = searchSong.split('spotify:track:');
      SpotifyApiService.getInstance()
        .getTrack(songId[1])
        .then(genreResponse => {
          if (isStale()) return;
          //   setSongs([genreResponse.data]);
          //   setDisplaySongCover(false);
          const responseData = genreResponse.data;
          let data = [
            {
              key: 1,
              id: responseData?.id,
              title: responseData?.name,
              image: responseData?.album.images[0].url,
              artist: responseData?.artists[0].name,
              externalUrl: responseData.external_urls.spotify,
              previewUrl: responseData?.preview_url,
              clickHandle: clickHandle,
              clickHandle1: clickHandle1,
              songUri: responseData?.uri,
              Edit: () => {},
              popularity: responseData?.popularity ?? '--',
            },
          ];
          dispatch({
            type: 'SET_SONGS_SEARCH_LIST',
            payload: data,
          });
          dispatch({
            type: 'SET_SEARCH_TRACKS_TOTAL',
            payload: 1,
          });
        });
    } else {
      SpotifyApiService.getInstance()
        .searchTracks(searchSong, 10, pagination ? state.searchedSongs.length : 0)
        .then(genreResponse => {
          if (isStale()) return;
          const tracksTotal = genreResponse?.data?.tracks?.total;
          if (!pagination && typeof tracksTotal === 'number') {
            dispatch({
              type: 'SET_SEARCH_TRACKS_TOTAL',
              payload: tracksTotal,
            });
          }
          let data = genreResponse?.data?.tracks?.items.map((data, index) => {
            const url = data?.album?.images?.length ? data?.album?.images[0].url : null;

            const artist = data?.artists?.length ? data?.artists[0].name : null;
            setPage(page + 1);
            return {
              key: 0,
              id: data.id,
              title: data.name,
              image: url,
              artist: artist,
              previewUrl: data.preview_url,
              clickHandle: clickHandle,
              clickHandle1: clickHandle1,
              songUri: data.uri,
              isPlaying: false,
              externalUrl: data.external_urls.spotify,
              popularity: data.popularity,
              rowNumber: { indexes: (page - 1) * 10 + index + 1 },
              Edit: () => {},
            };
          });
          if (pagination) {
            dispatch({
              type: 'SET_SONGS_SEARCH_LIST',
              payload: [...state.searchedSongs, ...data],
            });
          } else {
            dispatch({
              type: 'SET_SONGS_SEARCH_LIST',
              payload: data,
            });
          }
        })

        .catch(async error => {
          if (error.response?.data?.error?.status === 401 || error.response?.status === 400) {
          }
        });
    }
  };
  // Effect to read search query from URL params when location changes
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const queryParam = urlParams.get('q');
    if (queryParam && !state.searchSong) {
      dispatch({
        type: "SET_SEARCHED_SONG",
        payload: queryParam,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (state.searchSong !== songtext) {
      setsongtext(state.searchSong);
      fetchData(state.searchSong, loginState, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchSong, loginState]);

  const [editType, setEditType] = useState('');
  const [editAddToPlaylistModal, setEditAddToPlaylistModal] = useState(false);
  const [selectedSong, setSelectedSong] = useState('');
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);

  const showModalDelete = () => {
    setIsModalOpenDelete(true);
  };

  const handleOkDelete = () => {
    setIsModalOpenDelete(false);
  };

  const handleCancelDelete = () => {
    setIsModalOpenDelete(false);
  };
  const menu = a => {
    setSelectedSong(a);
    setAddModalVisible(true);
    setSongURI(a.songUri);
  };
  return (
    <div style={{ marginTop: '0%' }}>
      {isEmptyOrNil(state.searchedSongs) ? (
        <EmptySearchState />
      ) : (
        <PlaylistStyle>
          <div className="searchContent">
            <InfiniteScroll
              pageStart={1}
              loadMore={() => {
                fetchData(state.searchSong, loginState, true);
              }}
              hasMore={
                typeof state.searchTracksTotal === 'number'
                  ? state.searchedSongs.length < state.searchTracksTotal
                  : state.searchedSongs.length > 0 && state.searchedSongs.length % 10 === 0
              }
              loader={
                <div className="load-wrapp">
                  <div className="load-1">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                  </div>
                </div>
              }
            >
              <SongsTable
                state={state.searchedSongs}
                playlistState={playlistState}
                menu={menu}
                HideAddNote={true}
                HideDates={true}
                hideMenu={searchPlaylist}
                spotifyTrue={true}
                fromBrowse={true}
              />
            </InfiniteScroll>
          </div>
        </PlaylistStyle>
      )}
      <AddToPlayListModalSearch
        isModalVisible={isAddModalVisible}
        setIsModalVisible={setAddModalVisible}
        songURI={songURI}
        setSongURI={setSongURI}
        hideRadioButtons={false}
        hideUriInput={true}
        dataSearched={selectedSong}
      />

      <EditAddToPlayListModal
        isModalVisible={editAddToPlaylistModal}
        setIsModalVisible={setEditAddToPlaylistModal}
        editType={editType}
        setEditType={setEditType}
      />
      <DeleteModal
        handleCancel={handleCancelDelete}
        showModal={showModalDelete}
        isModalOpen={isModalOpenDelete}
        handleOk={handleOkDelete}
        heading={'Delete from playlist'}
        headingText={'Are you sure you want to delete this song?'}
        button1={'Delete'}
        button2={'Cancel'}
      />
    </div>
  );
};

export default SearchSongsTable;
